import React, { useState } from "react";
import BgImageStep1 from "../../assets/images/Gender_Affirming_support.jpg";
import BgImageStep2 from "../../assets/images/Gender_affirmity_2.jpg";
import BgImageStep3 from "../../assets/images/Gender_affirmity_3.jpg";
import { useNavigate } from "react-router-dom";
const Welcomescreen = ({ userName = "Test_nhtr" }) => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();

  const goNext = () => {
    if (step < 3) setStep(step + 1);
  };

  const goBack = () => {
    if (step === 1) {
      console.log("Navigate back to previous page");
    } else {
      setStep(step - 1);
    }
  };

  const handleBookAppointment = () => {
   navigate("/book-appointment");
  };

  const handleSkip = () => {
    navigate("/home");
  };

  const getBgImage = () => {
    if (step === 1) return BgImageStep1;
    if (step === 2) return BgImageStep2;
    return BgImageStep3;
  };

  return (
    <div className="welcome-container">

      {/* BACKGROUND IMAGE */}
      <div
        className="welcome-bg"
        style={{ backgroundImage: `url(${getBgImage()})` }}
      />

      {/* OVERLAY */}
      <div className="welcome-overlay" />

      {/* ================= BACK BUTTON (MATCHES ELIGIBILITY UI) ================= */}
      {step !== 1 && (
        <div className="col-lg-12 mt-5 d-flex inner-page-heading-wrapper" style={{ position: "relative", zIndex: 5 }}>
          <button className="win-back-btn" onClick={goBack}>
            <span>
              <i className="bi bi-chevron-left"></i> Back
            </span>
          </button>
        </div>
      )}

      {/* ================= CONTENT AREA ================= */}
      <div className="welcome-content step-content-fixed">

        {/* ---------------- STEP 1 ---------------- */}
        {step === 1 && (
          <>
            <h2 className="page-heading-primary mt-4">
              Welcome to WIN,<br />
              <span className="welcome-name">{userName}</span>
            </h2>

            <p className="page-description text-mute mt-3">
              We’re so glad you're here—and honored to support you through your
              gender-affirming journey. From expert guidance to emotional support,
              WIN is here to help you navigate what’s next.
            </p>

            <div className="progress-dash-bar mt-4">
              <div className="dash active"></div>
              <div className="dash"></div>
              <div className="dash"></div>
            </div>

            <div className="paymentstep-btn-wrapper mt-5">
              <button className="win-btn-secondaryy w-100" onClick={goNext}>
                NEXT
              </button>
            </div>
          </>
        )}

        {/* ---------------- STEP 2 ---------------- */}
        {step === 2 && (
          <>
            <h2 className="page-heading-primary mt-4">
              Explore your<br />
              <span className="welcome-name">WIN benefit.</span>
            </h2>

            <p className="page-description text-mute mt-3">
              Want to know everything your WIN benefits cover? Simply tap the
              Benefits tab on your WINApp to learn more.
            </p>

            <div className="progress-dash-bar mt-4">
              <div className="dash"></div>
              <div className="dash active"></div>
              <div className="dash"></div>
            </div>

            <div className="paymentstep-btn-wrapper mt-5">
              <button className="win-btn-secondaryy w-100" onClick={goNext}>
                NEXT
              </button>
            </div>
          </>
        )}

        {/* ---------------- STEP 3 ---------------- */}
        {step === 3 && (
          <>
            <h2 className="page-heading-primary mt-4">
              What happens<br />
              <span className="welcome-name">now?</span>
            </h2>

            <p className="page-description text-mute mt-3">
              Every WIN journey begins with a Nurse Care Advocate appointment,
              which you can book right now.
            </p>

            <div className="progress-dash-bar mt-4">
              <div className="dash"></div>
              <div className="dash"></div>
              <div className="dash active"></div>
            </div>

            <div className="paymentstep-btn-wrapper mt-4">
              <button
                className="win-btn-secondaryy w-100"
                onClick={handleBookAppointment}
              >
                Book Appointment
              </button>
            </div>

            <div className="paymentstep-btn-wrapper mt-3">
              <button
                className="win-btn-primaryy w-100"
                onClick={handleSkip}
              >
                Skip
              </button>
            </div>
          </>
        )}

      </div>
    </div>
  );
};

export default Welcomescreen;
